// extracted by mini-css-extract-plugin
export var fullHeightState = "_1e-7";
export var headerCell = "_1e-1";
export var loadingStateCell = "_1e-4";
export var rowWrapper = "_1e-3";
export var standaloneTable = "_1e-8";
export var standaloneTableWithBodyFill = "_1e-9";
export var stateCell = "_1e-5";
export var table = "_1e-0";
export var tableBodyFiller = "_1e-6";
export var white = "_1e-2";